<script setup lang="ts">
/**
 * UI-kit component
 * Category: Paginations
 * Name: AppPaginationLink
 */
import type { AppPaginationLinkProps } from '../types/interfaces'

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons'

import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'AppPaginationLink',
})

defineProps<AppPaginationLinkProps>()

defineEmits<{
  click: []
}>()
</script>

<template>
  <span
    v-if="item.variant === 'ellipsis'"
    class="app-pag-link static"
  >
    {{ item.label }}
  </span>
  <button
    v-else
    type="button"
    :class="['app-pag-link', { active: item.active, disabled: item.disabled }]"
    :disabled="item.disabled"
    @click="$emit('click')"
  >
    <AppIcon
      v-if="item.variant === 'prev'"
      :icon="faChevronLeft"
      size="small"
    />
    <AppIcon
      v-else-if="item.variant === 'next'"
      :icon="faChevronRight"
      size="small"
    />
    <span v-else>{{ item.label }}</span>
  </button>
</template>

<style lang="scss" scoped src="../styles/_app-pagination-link.scss" />
